






































import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { CashbackCrmBonusUseCase } from '@/usecases/cliente/CashbackCrmBonusUseCase'
import { Vue, Component, Ref } from 'vue-property-decorator'
import { CrmBonusModule } from '@/store/vuex/venda/CrmBonusStore'

@Component({
	components: {
		
	},
})
export default class DialogoDeConfirmacaoDePINCashback extends Vue {
	@Ref() form!: HTMLFormElement

	cashbackCrmBonusUseCase = new CashbackCrmBonusUseCase()

	pin: string | null = null
	mostra = false
	salvando = false
	reenviando = false
	cnpjOuCpfCliente: string | null = null
	lojaId: string | null = null
	reenviarHabilitado = false
	tempoRestanteReenvio = 0
	intervaloReenvio: any = null
	resolveConfirmacao: ((res: { pinValidado: boolean; pinMaster: boolean }) => void) | null = null

	mostrar(lojaId: string, cnpjOuCpfCliente: string): Promise<{ pinValidado: boolean; pinMaster: boolean }> {
		this.lojaId = lojaId
		this.cnpjOuCpfCliente = cnpjOuCpfCliente

		this.mostra = true
		this.iniciarContadorReenvio()

		setTimeout(() => {
			this.form.resetValidation()
		})

		return new Promise<{ pinValidado: boolean; pinMaster: boolean }>(resolve => this.resolveConfirmacao = resolve)
	}

	esconder() {
		this.mostra = false
		this.pin = null
		this.salvando = false
		this.reenviando = false
		clearInterval(this.intervaloReenvio)
		this.reenviarHabilitado = false
		this.tempoRestanteReenvio = 0
	}

	async reenviarPIN(){
		if (this.cnpjOuCpfCliente === null || this.lojaId === null) return

		this.reenviando = true
		try{
			const params = {
				userId: CrmBonusModule.dados.userIdNoCrm,
				requestHash: CrmBonusModule.dados.requestHash,
				lojaId: this.lojaId,
			}

			await this.cashbackCrmBonusUseCase.reenviarPINParaCliente(this.cnpjOuCpfCliente, params)
			this.iniciarContadorReenvio()

			AlertModule.setSuccess("PIN Reenviado ao cliente!")
		}
		catch(error: any){
			AlertModule.setError(error)
			this.reenviarHabilitado = true
		}
		finally{
			this.reenviando = false
		}
	}

	async confirmarPIN() {
		if (this.pin === '' || this.pin === null) return
		if (this.cnpjOuCpfCliente === null || this.lojaId === null) return
		if (CrmBonusModule.dados.userIdNoCrm === null || CrmBonusModule.dados.requestHash === null) return 

		try{
			const params = {
				userId: CrmBonusModule.dados.userIdNoCrm,
				requestHash: CrmBonusModule.dados.requestHash,
				lojaId: this.lojaId,
			}

			const responseValidacaoPIN = await this.cashbackCrmBonusUseCase.validarPINInformado(params, this.pin)
			CrmBonusModule.setDados({
				pinCrmValidado: responseValidacaoPIN.pinValidado,
				usouPinMaster: responseValidacaoPIN.pinMaster,
			})

			if (CrmBonusModule.dados.pinCrmValidado) {
				AlertModule.setSuccess("PIN válido!")
				this.mostra = false
				this.resolveConfirmacao?.({ pinValidado: true, pinMaster: CrmBonusModule.dados.usouPinMaster })
			} else {
				AlertModule.setError("PIN inválido, tente novamente.")
			}
			
		}
		catch(error: any){
			AlertModule.setError(error)
		}
		finally{
			this.salvando = false
		}
	}

	iniciarContadorReenvio() {
		this.reenviarHabilitado = false
		this.tempoRestanteReenvio = 120 

		this.intervaloReenvio = setInterval(() => {
			this.tempoRestanteReenvio--

			if (this.tempoRestanteReenvio <= 0) {
				clearInterval(this.intervaloReenvio)
				this.reenviarHabilitado = true
			}
		}, 1000)
	}

}
